import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api, type Session } from './api';

export const sessionKey = ['session'] as const;

export function useSession() {
  return useQuery({ queryKey: sessionKey, queryFn: () => api.get<Session>('/session'), staleTime: 60_000 });
}

export function useRefreshSession() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: sessionKey });
}

